// @lemontaigu/fin-adapters — C6 Finance adapters and the composition helper.
import type { LedgerReader } from '@lemontaigu/fin-core';
import { SupabaseLedgerReader, type SupabaseClient } from './supabase/ledgerReader.js';

export {
  MalformedRow,
  SupabaseLedgerReader,
  toCustomerBalance,
  toCustomerMovement,
  toCentralisation,
  toDocumentDetail,
  toFinError,
  toJournalLine,
  toLedgerStatus,
  toTrialBalanceLine,
} from './supabase/ledgerReader.js';
export type { SupabaseClient } from './supabase/ledgerReader.js';

/** What the Comptabilité screen is given. One port today; the finance screens that follow add theirs here. */
export interface FinContainer {
  readonly ledger: LedgerReader;
}

/**
 * The one place the adapter is built (a composition root calls this; a component never does).
 * `propertyCode` binds the reader to one établissement.
 */
export function createFinContainer(db: SupabaseClient, propertyCode: string): FinContainer {
  return { ledger: new SupabaseLedgerReader(db, propertyCode) };
}
